import { render, staticRenderFns } from "./AttachmentWithStatus.vue?vue&type=template&id=35b21482&scoped=true"
import script from "./AttachmentWithStatus.vue?vue&type=script&lang=ts"
export * from "./AttachmentWithStatus.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentWithStatus.vue?vue&type=style&index=0&id=35b21482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b21482",
  null
  
)

export default component.exports